import { act } from "react-dom/test-utils";
import actionTypes from "../actions/actionTypes";

const initialState = {
  userVisualReport: [],
  userDistributionSummary: [],
  classDistributionSummary: [],
  classVisualReport: [],
  tenantUsers: [],
  trainingTypes: [],
  filterUserDistributionSummary: [],
  filterUserVisualReport: [],
  filterClassDistributionSummary: [],
  filterClassVisualReport: [],
  assignedClass: [],
  userGroup: [],
  className: [],
  useDistributionReport: null,
  userShotClassReport: null,
  countryList: [],
  stateList: [],
  cityList: [],
  workOfficeList: [],
  productCategoryList: [],
  userClassCompletionReport: null,
  userClassCompletionGraphReport: null,
  classWithSurvey: [],
  classWithScoredSurvey: [],
  surveyReport: [],
  searchClassName: "",
  searchUserGroup: "",
  sendRemainderMail: "",
  defaultShotClassInformation: [],
  userDistributionCSV: "",
  quizReport: "",
  accessReport: "",
  totalActiveUsers: 0,
  mobileInstallationCount: [],
  userGroupAccessDetails: [],
  userGroupClassUsageDetails: [],
  shotclassCompletionTrend: [],
  classWiseUsageDetails: [],
  noOfUserAccessedShotclassApplication: 0,
  noOfUserAccessedShotclasses: 0,
  mobileAppInstallationCount: 0,
  applicationAccessUserDetails: [],
  userResponseToQuestions: [],
};

const reportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.reportTypes.graphicalReportTypes.GET_USER_VISUAL_REPORT:
      return { ...state, userVisualReport: payload };
    case actionTypes.reportTypes.graphicalReportTypes
      .GET_USER_DISTRIBUTION_SUMMARY:
      return { ...state, userDistributionSummary: payload };
    case actionTypes.reportTypes.graphicalReportTypes
      .GET_CLASS_DISTRIBUTION_SUMMARY:
      return { ...state, classDistributionSummary: payload };
    case actionTypes.reportTypes.graphicalReportTypes.GET_CLASS_VISUAL_REPORT:
      return { ...state, classVisualReport: payload };
    case actionTypes.reportTypes.commonTypes.GET_TENANT_USERS:
      return { ...state, tenantUsers: payload };
    case actionTypes.reportTypes.commonTypes.GET_TRAINING_TYPES:
      return { ...state, trainingTypes: payload };
    case actionTypes.reportTypes.graphicalReportTypes
      .FILTER_USER_DISTRIBUTION_SUMMARY:
      return { ...state, filterUserDistributionSummary: payload };
    case actionTypes.reportTypes.graphicalReportTypes.FILTER_USER_VISUAL_REPORT:
      return { ...state, filterUserVisualReport: payload };
    case actionTypes.reportTypes.graphicalReportTypes
      .FILTER_CLASS_DISTRIBUTION_SUMMARY:
      return { ...state, filterClassDistributionSummary: payload };
    case actionTypes.reportTypes.graphicalReportTypes
      .FILTER_CLASS_VISUAL_REPORT:
      return { ...state, filterClassVisualReport: payload };
    case actionTypes.reportTypes.graphicalReportTypes.GET_ASSIGNED_CLASS:
      return { ...state, assignedClass: payload };
    case actionTypes.reportTypes.commonTypes.GET_USER_GROUP:
      return { ...state, userGroup: payload };
    case actionTypes.reportTypes.commonTypes.GET_CLASS_NAME:
      return { ...state, className: payload };
    case actionTypes.reportTypes.tabularReportTypes
      .GET_USER_DISTRIBUTION_REPORT:
      return { ...state, useDistributionReport: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_USER_SHOTCLASS_REPORT:
      return { ...state, userShotClassReport: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_SHOTCLASS_USER_REPORT:
      return { ...state, shotClassUserReport: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_COUNTRY_LIST:
      return { ...state, countryList: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_STATE_LIST:
      return { ...state, stateList: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_CITY_LIST:
      return { ...state, cityList: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_WORK_OFFICE_LIST:
      return { ...state, workOfficeList: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_PRODUCT_CATEGORY_LIST:
      return { ...state, productCategoryList: payload };
    case actionTypes.reportTypes.tabularReportTypes
      .GET_USER_CLASS_COMPLETION_REPORT:
      return { ...state, userClassCompletionReport: payload };
    case actionTypes.reportTypes.tabularReportTypes
      .GET_USER_CLASS_COMPLETION_GRAPH_REPORT:
      return { ...state, userClassCompletionGraphReport: payload };
    case actionTypes.reportTypes.surveyReportTypes.GET_CLASSES_WITH_SURVEY:
      return { ...state, classWithSurvey: payload };
    case actionTypes.reportTypes.surveyReportTypes
      .GET_CLASSES_WITH_SCORED_SURVEY:
      return { ...state, classWithScoredSurvey: payload };
    case actionTypes.reportTypes.surveyReportTypes.GET_SURVEY_REPORT:
      return { ...state, surveyReport: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_SEARCH_CLASS_NAME:
      return { ...state, searchClassName: payload };
    case actionTypes.reportTypes.tabularReportTypes.SEND_RAMAINDER:
      return { ...state, sendRemainderMail: payload };
    case actionTypes.reportTypes.tabularReportTypes.GET_SEARCH_USER_GROUP:
      return { ...state, searchUserGroup: payload };
    case actionTypes.reportTypes.analyticalReportTypes
      .GET_DEFAULT_SHOTCLASS_INFORMATION:
      return { ...state, defaultShotClassInformation: payload };
    case actionTypes.reportTypes.tabularReportTypes
      .GET_USER_DISTRIBUTION_CSV_REPORT:
      return { ...state, userDistributionCSV: payload };
    case actionTypes.reportTypes.quizReportTypes.GET_QUIZ_REPORT:
      return { ...state, quizReport: payload };
    case actionTypes.reportTypes.accessReportTypes.GET_ACCESS_REPORT:
      return { ...state, accessReport: payload };
    case actionTypes.reportTypes.adoptionReportTypes.GET_TOTAL_ACTIVE_USERS:
      return { ...state, totalActiveUsers: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_MOBILE_INSTALLATION_COUNT:
      return { ...state, mobileInstallationCount: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_USERGROUP_ACCESS_DETAILS:
      return { ...state, userGroupAccessDetails: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_USERGROUP_CLASS_USAGE_DETAILS:
      return { ...state, userGroupClassUsageDetails: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_SHOTCLASS_COMPLETION_TREND:
      return { ...state, shotclassCompletionTrend: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_CLASS_WISE_USAGE_DETAILS:
      return { ...state, classWiseUsageDetails: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_NUMBER_OF_USER_ACCESSED_SHOTCLASS_APPLICATION:
      return { ...state, noOfUserAccessedShotclassApplication: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_NUMBER_OF_USER_ACCESSED_SHOTCLASSESS:
      return { ...state, noOfUserAccessedShotclasses: payload };
    case actionTypes.reportTypes.adoptionReportTypes
      .GET_MOBILE_APP_INSTALLATION_COUNT:
      return { ...state, mobileAppInstallationCount: payload };
    case actionTypes.reportTypes.accessReportTypes
      .GET_APPLICATION_ACCESS_USER_DETAILS:
      return { ...state, applicationAccessUserDetails: payload };
    case actionTypes.reportTypes.quizReportTypes.GET_USER_RESPONSE_TO_QUESTIONS:
      return { ...state, userResponseToQuestions: payload };
    default:
      return state;
  }
};

export default reportReducer;
